import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { statusSwitcherVariantsColor } from '@frontend/design-system';

export const buttonStyle = css`
  :hover {
    background-color: ${theme.colors.neutral10};
  }
`;

export const containerStyle = css`
  width: 32px;
  height: 32px;
  align-items: center;
  display: flex;
  justify-content: center;

  .button-icon {
    color: ${statusSwitcherVariantsColor['success'].color};
  }
`;
